import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState, useEffect } from "react";
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import moment from "moment";
import EmployeeDropdown from "../employee/dropdown"
import ClientDropdown from "../client/dropdown"
import { MyFetch } from "../../App";
import { useLocation, useNavigate } from 'react-router-dom';



const TasksForm = (props) => {
  const [validated, set_Validated] = useState(false);
  const [form_Data, set_Form_Data] = useState({
    task_name: "",
    client_id: 0,
    emp_id: 0,
    date_due: "",
    task_desc: "",

  });
  const navigate = useNavigate();

  const submitFn = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    const form = event.currentTarget; // Get the form element

    // Perform validation
    if (form.checkValidity() === false || !form_Data.date_due) {
      event.stopPropagation(); // Stop the form from submitting if validation fails
      set_Validated(true); // Trigger validation feedback styling
    } else {
      set_Validated(true);


      MyFetch("https://easytasks.in/tasks/create", form_Data, "POST")
        .then((res) => res.json())
        .then((data) => {
          set_Form_Data({
            task_name: "",
            client_id: 0,
            emp_id: 0,
            date_due: "",
            task_desc: "",
          }); // Clear the form data after successful submission
          alert("Task created successfully!")
          navigate('/tasks/list'); // Notify the user
        })
        .catch((error) => {
          console.error("Error creating task:", error);
          alert("Failed to create task."); // Notify the user of any errors
        });
    }
  };


  const chngFn = (event) => {
    const { name, value } = event.target;
    set_Form_Data({
      ...form_Data,
      [name]: value,
    });
  };

  const chngDt = (value) => {
    set_Form_Data({
      ...form_Data,
      "date_due": moment(value).format("MM/DD/YYYY"),
    });
    console.log(form_Data)
    console.log(moment(value).format("MM/DD/YYYY"));
  };

  return (

    <Container className='mt-5'>
      <Row className="justify-content-md-center">
        <Col xs lg="5" >
          <h2 className='my-5'><b>ADD A TASK</b></h2>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs lg="5">
          <Form noValidate validated={validated} onSubmit={submitFn}>

            <Form.Group className="mb-3" controlId="tasksTask_name">
              <Form.Label>Task Name</Form.Label>
              <Form.Control
                type="text"
                name="task_name"
                value={form_Data.task_name}
                onChange={chngFn}
                pattern="^[a-zA-Z0-9 ]+$"
                required
                isInvalid={
                  validated &&
                  !/^[a-zA-Z0-9 ]+$/.test(form_Data.task_name)
                }
              />
              <Form.Control.Feedback type="invalid">
                Please enter a valid Name (alphanumeric
                characters only).
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="tasksTask_desc">
              <Form.Label>Task Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="task_desc"
                value={form_Data.task_desc}
                onChange={chngFn}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="tasksDate_due">
              <Form.Label>Date Due</Form.Label>
              <div>
                <DatePicker
                  name="date_due"
                  onChange={chngDt}
                  value={form_Data.date_due ? new Date(form_Data.date_due) : null}
                  className={validated && !form_Data.date_due ? 'is-invalid' : ''}
                />
                {validated && !form_Data.date_due && (
                  <div className="invalid-feedback"> Due Date is required.</div>
                )}
              </div>
            </Form.Group>

            <Form.Group className="mb-3" controlId="tasksEmp_id">
              <Form.Label>Employee Assigned</Form.Label>
              <EmployeeDropdown
                name="emp_id"
                onChange={chngFn}
                value={form_Data.emp_id}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="tasksClient_id">
              <Form.Label>Client</Form.Label>
              <ClientDropdown
                name="client_id"
                onChange={chngFn}
                value={form_Data.client_id}
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              Create
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default TasksForm;